import { useEffect, useState } from "react";

export default function ConnectedServices() {
    const [connections, setConnections] = useState({
        SmartFHIR: false,
        LabCorp: false,
        SimonMed: false,
    });

    useEffect(() => {
        const isSmartConnected = !!localStorage.getItem("accessToken");
        setConnections((prev) => ({ ...prev, SmartFHIR: isSmartConnected }));
    }, []);

    const handleToggleConnection = (provider) => {
        if (provider === "SmartFHIR") {
            if (!connections.SmartFHIR) {
                // Connect
                startSmartOAuth();
            } else {
                // Disconnect
                localStorage.removeItem("accessToken");
                localStorage.removeItem("patientId");
                setConnections((prev) => ({
                    ...prev,
                    SmartFHIR: false,
                }));
            }
        } else {
            // Other services
            setConnections((prev) => ({
                ...prev,
                [provider]: !prev[provider],
            }));
        }
    };

    const startSmartOAuth = () => {
        const clientId = "my_web_app";
        const redirectUri = encodeURIComponent(`${window.location.origin}/callback`);
        const scope = encodeURIComponent("launch openid fhirUser patient/*.read");

        // Use the AUTH endpoint, not FHIR API endpoint
        const authBase = "https://launch.smarthealthit.org/v/r4/sim/WzMsIiIsIiIsIkFVVE8iLDAsMCwwLCIiLCIiLCIiLCIiLCIiLCIiLCIiLDAsMSwiIl0/auth/authorize";

        const aud = encodeURIComponent(`https://launch.smarthealthit.org/v/r4/sim/WzMsIiIsIiIsIkFVVE8iLDAsMCwwLCIiLCIiLCIiLCIiLCIiLCIiLCIiLDAsMSwiIl0/fhir`);

        window.location.href = `${authBase}?response_type=code&client_id=${clientId}&scope=${scope}&redirect_uri=${redirectUri}&aud=${aud}`;
    };


    return (
        <div className="pt-4 pb-8 space-y-6 border-b">
            <h1 className="py-2 text-2xl font-semibold">Connected Services</h1>

            <div className="space-y-4">
                {[
                    { name: "SMART FHIR Sandbox", key: "SmartFHIR" },
                    { name: "LabCorp", key: "LabCorp" },
                    { name: "SimonMed", key: "SimonMed" },
                ].map((service) => (
                    <div
                        key={service.key}
                        className="flex items-center justify-between p-4 border rounded bg-white shadow-sm"
                    >
                        <div>
                            <p className="font-medium text-gray-800">{service.name}</p>
                            <p className="text-sm text-gray-500">
                                {connections[service.key]
                                    ? "Connected"
                                    : "Not connected"}
                            </p>
                        </div>
                        <button
                            onClick={() => handleToggleConnection(service.key)}
                            className={`px-4 py-2 text-sm rounded transition ${connections[service.key]
                                ? "bg-red-600 text-white hover:bg-red-700"
                                : "bg-blue-600 text-white hover:bg-blue-700"
                                }`}
                        >
                            {connections[service.key] ? "Disconnect" : "Connect"}
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
}
